// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "notification_preference".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "notification_preference" table (1:1 with a DB row, on the wire). */
export const notificationPreferenceAtomSchema = z.object({
    id: z.string(),
    userId: z.string(),
    bookingReminders: z.boolean(),
    bookingAlerts: z.boolean(),
    messageNotifications: z.boolean(),
    marketingEmails: z.boolean(),
    appUpdates: z.boolean(),
    weeklyDigest: z.boolean(),
    preferences: z.unknown(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=notificationPreference.js.map